export default [
    {
        key: 'ManualPriceTaxSeparatedModal',
        getComponent: function () { return import('./ManualPriceTaxSeparatedModal'); },
        width: 600,
        title: i18n.get('发票价税分离下发'),
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'LogModal',
        getComponent: function () { return import('./LogModal'); },
        title: '下发记录',
        width: 800,
    },
];
